export const userTypes = {
    DOWNLOAD_REQUEST: "USER_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "USER_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "USER_DOWNLOAD_FAILURE",
    FETCH_USER:"FETCH_USER",
    FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
    FETCH_USER_ERROR: "FETCH_USER_ERROR",
    FETCH_USER_LIST: "FETCH_USER_LIST",
    FETCH_USER_LIST_SUCCESS: "FETCH_USER_LIST_SUCCESS",
    FETCH_USER_LIST_ERROR: "FETCH_USER_LIST_ERROR",
    SET_CURRENT_MODAL: 'SET_CURRENT_MODAL',
    FETCH_ROLES_REQUEST: "FETCH_ROLES_REQUEST",
    FETCH_ROLES_SUCCESS: "FETCH_ROLES_SUCCESS",
    FETCH_ROLES_FAILURE: "FETCH_ROLES_FAILURE",
    UPDATE_PAGINATION_REQUEST: "USER_UPDATE_PAGINATION_REQUEST",
    RESET_USER_FILTERS: "RESET_USER_FILTERS",
    RESET_FILTERS: "RESET_FILTERS",
};

export const setCurrentModal = (data) => ({
    type: userTypes.SET_CURRENT_MODAL,
    payload: data,
});

export const downloadRequest = (data) => ({
    type: userTypes.DOWNLOAD_REQUEST,
    payload: data
});

export const downloadSuccess = (resp) => ({
    type: userTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: userTypes.DOWNLOAD_FAILURE,
    payload: error
});

export const fetchUser = () => ({
    type: userTypes.FETCH_USER
})

export const fetchUserSuccess = (data) => ({
    type: userTypes.FETCH_USER_SUCCESS,
    payload: data
})

export const fetchUserError = (err) => ({
    type: userTypes.FETCH_USER_ERROR,
    payload: err
})

export const fetchUserList = (data) => ({
    type: userTypes.FETCH_USER_LIST,
    payload: data
})

export const fetchUserListSuccess = (data, totalUserCount) => ({
    type: userTypes.FETCH_USER_LIST_SUCCESS,
    payload: data,
    totalUserCount
})

export const fetchUserListError = (err) => ({
    type: userTypes.FETCH_USER_LIST_ERROR,
    payload: err
})

export const fetchRolesListRequest = () => ({
    type: userTypes.FETCH_ROLES_REQUEST,
});

export const fetchRolesListSuccess = (data) => ({
    type: userTypes.FETCH_ROLES_SUCCESS,
    payload: data,
});

export const fetchRolesListFailure = (error) => ({
    type: userTypes.FETCH_ROLES_FAILURE,
    payload: error,
});

export const updatePaginationRequest = (req) => ({
    type: userTypes.UPDATE_PAGINATION_REQUEST,
    payload: req
});
export const resetFilters = () => ({
    type: userTypes.RESET_FILTERS,
});